import { saveAnswer } from "@educaplay/store/slices/gameSlice";
import { useSelector } from "react-redux";
import NavContainer from "../NavContainer";
import { MultiQuestion } from "./MultiQuestion";
import { SingleQuestion } from "./SingleQuestion";
import { TextQuestion } from "./TextQuestion";
import { useDispatch } from "react-redux";
import { QUESTION_TYPE } from "../../utils/constants";
import { useEffect, useState } from "react";

const diccionario = {
    [QUESTION_TYPE.TextQuestion]: TextQuestion,
    [QUESTION_TYPE.SingleQuestion]: SingleQuestion,
    [QUESTION_TYPE.MultiQuestion]: MultiQuestion
}

const Question = (props) => {
    const { question, onAnswer } = props;
    const Component = diccionario[question.questionType];
    const dispatch = useDispatch();
    const isExamMode = useSelector(state => state.game.examMode);
    const [passFinalQuestion, setPassFinalQuestion] = useState(false);
    const currentIndex = useSelector(state => state.game.currentIndex);
    const questions = useSelector(state => state.game.questions);

    useEffect(() => {

        if (currentIndex === questions.length - 1) setPassFinalQuestion(true);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex])

    const onExamAnswer = (answer) => {
        dispatch(saveAnswer(answer));
    }

    return (
        <>

            <Component
                question={question}
                onAnswer={isExamMode ? onExamAnswer : onAnswer}
                key={question.id} 
                passFinalQuestion={passFinalQuestion}/>
            {isExamMode && <NavContainer />}
        </>
    )
}

export default Question;